<template>
  <div>
    <section class="content-header mt-2">
      <h3>Connection: {{ connection.name }}</h3>
      <b-table
        stacked
        :items="[connection]" />
    </section>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    name: "Connection",
    data() {
      return {
        connectionId: this.$route.params.connectionId
      };
    },
    computed: {
      ...mapState("connections", {
        connection: "connection"
      })
    },
    created() {
      this.$store.dispatch("connections/show", this.connectionId);
    },
    beforeDestroy() {
      this.$store.commit("connections/SET_CONNECTION", []);
    },
  };
</script>